export const actions = {
  AUTHENTICATE: "AUTHENTICATE",
  UPDATE_POLICY: "RNW-update-Policy",
  UPDDATE_QOUTATION: "RNW-update-qoutation",
  UPDATE_PROPOSAL: "RNW-update-proposal",
  UPDATE_USER_LOGGED_IN: "RNW-update-user-loggedin",
  UPDATE_DEFAULT_VALUES: "RNW-update-default-values",
  UPDATE_CURRENT_PLAN: "RNW-update-current-plan",
  UPDATE_RENEWAL_LIST: "RNW-update-renewal-List",
  UPDATE_CHOOSE_PRODUCT_CODE: "RNW-update-product-code",
  UPDATE_LOADING: "RNW-update-loading",
  UPDATE_CALLING_API: "RNW-update-calling-api",
  UPDATE_OTP_INDEX: "RNW-update-otp-index",
  UPDATE_YOB: "UPDATE_YOB",
  UPDATE_UID: "UPDATE_UID",
  UPDATE_COLOR: "UPDATE_COLOR",
  UPDATE_SAVE: "UPDATE_SAVE",
  CHANGE_DRIVER_SELECTED: "CHANGE_DRIVER_SELECTED",
};

export const setAuthentication = (payload) => ({
  type: actions.AUTHENTICATE,
  payload,
});

export const updateCurrentPolicy = (policy) => ({
  type: actions.UPDATE_POLICY,
  payload: policy,
});

export const updateLoggedInUser = (data) => ({
  type: actions.UPDATE_USER_LOGGED_IN,
  payload: data,
});

export const updateQuotationDetails = (quotationDetails) => ({
  type: actions.UPDDATE_QOUTATION,
  payload: quotationDetails,
});

export const updateProposalDetails = (proposalDetails) => ({
  type: actions.UPDATE_PROPOSAL,
  payload: proposalDetails,
});

export const updateDefaultValues = (data) => ({
  type: actions.UPDATE_DEFAULT_VALUES,
  payload: data,
});

export const updateCurrentPlan = (data) => ({
  type: actions.UPDATE_CURRENT_PLAN,
  payload: data,
});

export const updateRenewalList = (data) => ({
  type: actions.UPDATE_RENEWAL_LIST,
  payload: data,
});

export const updateChoosenProduct = (data) => ({
  type: actions.UPDATE_CHOOSE_PRODUCT_CODE,
  payload: data,
});

export const updateLoading = (data) => ({
  type: actions.UPDATE_LOADING,
  payload: data,
});
export const updateSave = (data) => ({
  type: actions.UPDATE_SAVE,
  payload: data,
});

export const updateCallingApi = (data) => ({
  type: actions.UPDATE_CALLING_API,
  payload: data,
});

export const updateOtpIndex = (data) => ({
  type: actions.UPDATE_OTP_INDEX,
  payload: data,
});

export const updateYob = (data) => ({
  type: actions.UPDATE_YOB,
  payload: data,
});

export const updateUid = (data) => ({
  type: actions.UPDATE_UID,
  payload: data,
});

export const setUpdateColor = (data) => ({
  type: actions.UPDATE_COLOR,
  payload: data,
});

export const changeIsDriverSelected = (val) => {
  return {
    type: actions.CHANGE_DRIVER_SELECTED,
    payload: val,
  };
};
